export function transformPermissions({
  permissions = [],
  globalCountries,
}: {
  permissions: any[];
  globalCountries: any[];
}) {
  return [
    ...extractGlobalPermissions(permissions),
    ...extractRegionalPermissions(permissions),
    ...extractCountryPermissions({ permissions, globalCountries }),
  ];
}

function isExplicitGlobal(permission) {
  return (permission.region || '').toUpperCase() === 'GLOBAL';
}

function extractGlobalPermissions(permissions) {
  const isImplicitGlobal = p => !p.region && !p.country_id;
  const globalPermission = permissions.find(
    p => isImplicitGlobal(p) || isExplicitGlobal(p),
  );
  if (!globalPermission) return [];
  return [
    {
      type: 'Root',
      text: 'Global',
      path: '/',
      metas: {
        region: globalPermission.region,
        countryId: null,
        id: globalPermission.id,
      },
    },
  ];
}

function extractRegionalPermissions(permissions) {
  const regionalPermissions = permissions.filter(
    p => p.region && !p.country_id && !isExplicitGlobal(p),
  );
  const formatRegionalPermission = ({ region, id }) => ({
    type: 'Region',
    text: region,
    path: `/${region}`,
    metas: { region, countryId: null, id },
  });
  return regionalPermissions.map(formatRegionalPermission);
}

function extractCountryPermissions({ permissions, globalCountries }) {
  const countryPermissions = permissions.filter(p => !!p.country_id);
  const idIndexedCountries = (globalCountries || []).reduce(
    (result, el) => ({ ...result, [el.id]: el }),
    {},
  );
  const formatCountryPermission = ({ country_id: countryId, id }) => {
    const { name, description, region } = idIndexedCountries[countryId] || {};
    const text = name || description || 'unknown';
    const path = `/${region}/${countryId}`;
    return { type: 'Country', text, path, metas: { region, countryId, id } };
  };
  return countryPermissions.map(formatCountryPermission);
}
